import React, { useEffect, useRef, useState } from 'react';

/* Thin fixed bar at the top of the viewport showing scroll progress through
   the article — purely decorative/UX, not part of the SEO surface. */
const ReadingProgress = () => {
  const [progress, setProgress] = useState(0);
  const frame = useRef(null);

  useEffect(() => {
    const update = () => {
      const doc = document.documentElement;
      const scrollTop = window.scrollY || doc.scrollTop;
      const height = doc.scrollHeight - doc.clientHeight || 1;
      setProgress(Math.min(100, Math.max(0, (scrollTop / height) * 100)));
      frame.current = null;
    };
    const onScroll = () => {
      if (frame.current == null) frame.current = requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (frame.current) cancelAnimationFrame(frame.current);
    };
  }, []);

  return <div className="v3-blog-progress" style={{ width: `${progress}%` }} aria-hidden="true" />;
};

export default ReadingProgress;
